import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      className="sticky top-0 z-50 transition-all duration-300"
      style={{
        background: 'rgba(255, 249, 240, 0.85)',
        backdropFilter: 'blur(16px)',
        borderBottom: '2px solid var(--pink)',
      }}
    >
      <div className="max-w-7xl mx-auto px-[5%]">
        <div className="flex items-center justify-between h-[72px]">
          {/* Logo */}
          <div
            className="flex items-center gap-2 cursor-pointer"
            onClick={() => scrollToSection('home')}
          >
            <span className="fredoka text-3xl" style={{ color: 'var(--dark)' }}>
              Thinkkool <span style={{ color: 'var(--pink-d)' }}>✨</span>
            </span>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-2">
            <button
              onClick={() => scrollToSection('home')}
              className="font-bold text-sm px-[18px] py-2 rounded-full transition-all duration-200"
              style={{ color: 'var(--mid)' }}
              onMouseEnter={(e) => {
                e.target.style.background = 'var(--pink)';
                e.target.style.color = 'var(--dark)';
              }}
              onMouseLeave={(e) => {
                e.target.style.background = 'transparent';
                e.target.style.color = 'var(--mid)';
              }}
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('categories')}
              className="font-bold text-sm px-[18px] py-2 rounded-full transition-all duration-200"
              style={{ color: 'var(--mid)' }}
              onMouseEnter={(e) => {
                e.target.style.background = 'var(--pink)';
                e.target.style.color = 'var(--dark)';
              }}
              onMouseLeave={(e) => {
                e.target.style.background = 'transparent';
                e.target.style.color = 'var(--mid)';
              }}
            >
              Categories
            </button>
            <button
              onClick={() => scrollToSection('products')}
              className="font-bold text-sm px-[18px] py-2 rounded-full transition-all duration-200"
              style={{ color: 'var(--mid)' }}
              onMouseEnter={(e) => {
                e.target.style.background = 'var(--pink)';
                e.target.style.color = 'var(--dark)';
              }}
              onMouseLeave={(e) => {
                e.target.style.background = 'transparent';
                e.target.style.color = 'var(--mid)';
              }}
            >
              Products
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="font-bold text-sm px-[18px] py-2 rounded-full transition-all duration-200"
              style={{ color: 'var(--mid)' }}
              onMouseEnter={(e) => {
                e.target.style.background = 'var(--pink)';
                e.target.style.color = 'var(--dark)';
              }}
              onMouseLeave={(e) => {
                e.target.style.background = 'transparent';
                e.target.style.color = 'var(--mid)';
              }}
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="font-extrabold text-sm px-[22px] py-2 rounded-full text-white transition-all duration-200"
              style={{ background: 'var(--pink-d)' }}
              onMouseEnter={(e) => {
                e.target.style.background = 'var(--lavender)';
                e.target.style.transform = 'translateY(-2px)';
              }}
              onMouseLeave={(e) => {
                e.target.style.background = 'var(--pink-d)';
                e.target.style.transform = 'translateY(0)';
              }}
            >
              Contact
            </button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors duration-200"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? (
              <X className="w-6 h-6" style={{ color: 'var(--dark)' }} />
            ) : (
              <Menu className="w-6 h-6" style={{ color: 'var(--dark)' }} />
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden py-4 border-t animate-in slide-in-from-top duration-200" style={{ borderColor: 'var(--pink)' }}>
            <nav className="flex flex-col space-y-4">
              {['home', 'categories', 'products', 'about', 'contact'].map((section) => (
                <button
                  key={section}
                  onClick={() => scrollToSection(section)}
                  className="text-left font-bold py-2 transition-colors duration-200 capitalize"
                  style={{ color: 'var(--mid)' }}
                  onMouseEnter={(e) => (e.target.style.color = 'var(--pink-d)')}
                  onMouseLeave={(e) => (e.target.style.color = 'var(--mid)')}
                >
                  {section}
                </button>
              ))}
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};
